import { ClipLoader } from "react-spinners";

interface DeleteCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  categoryName: string;
  isLoading: boolean;
}

const DeleteCategoryModal = ({
  isOpen,
  onClose,
  onConfirm,
  categoryName,
  isLoading,
}: DeleteCategoryModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 p-2 bg-gray-800 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <div className="text-lg mb-4">
          <span className="font-semibold">
            Are you sure you want to delete{" "}
          </span>
          "{categoryName}"?
        </div>
        <div className="flex justify-end space-x-3">
          <button onClick={onClose} className="px-4 py-2 rounded-lg">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg text-white bg-rose-500 flex items-center justify-center"
            disabled={isLoading}
          >
            {isLoading ? <ClipLoader size={20} color="white" /> : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCategoryModal;
